import React from 'react'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import * as id from '../common/AcountingId'
import { Box, Button, Typography } from '@mui/material'
import { Item } from '../../../common/snippets'
import { useState } from 'react'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import ExempDetailedTable from './tableReport/ExempDetailedTable'
import { useRef } from 'react'
import jsPDF from 'jspdf'
import moment from 'moment'
import autoTable from 'jspdf-autotable'
import { CSVLink } from 'react-csv'
import { useEffect } from 'react'
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal'
import { focusElemnt, navigation3 } from '../../../common/helper'
const ExempDetailed = (props) => {
    const { filterData, loginData, tableData, isPdfLoading, setIsPdfLoading } = props
    const tableRef = useRef(null);
    const [state, setState] = useState({
        generatePDF: false,
        load: false,
    })
    const [reportData, setReportData] = useState([])
    const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
    useEffect(() => {
        if (tableData.length) {
            let newData = tableData.map((obj) => ({ ...obj, isRowData: true, LRNo: ` ${obj.LRNo} ` }))
            setReportData(newData)
        } else {
            setReportData([{ isNoData: true, caption: 'No Records', colSpan: 23 }])
        }
    }, [tableData])
    const columnSummaryDefs = [
        { headerName: 'lrno', exportHead: 'LR\nNo', field: 'LRNo', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '160px', textAlign: 'left' } },
        { headerName: 'SenderGSTN', exportHead: 'Sender\nGSTIN', field: 'SenderGSTN', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '150px', textAlign: 'left' } },
        { headerName: 'ReceiverGSTN', exportHead: 'Receiver.\nGSTIN', field: 'ReceiverGSTN', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '150px', textAlign: 'left' } },
        { headerName: 'RecName', exportHead: 'Rec.\nName', field: 'RecName', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '150px', textAlign: 'left' } },
        { headerName: 'Sender', exportHead: 'Sender\nName', field: 'Sender', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '150px', textAlign: 'left' } },
        { headerName: 'GSTN/UIN of Receipeint', exportHead: 'GSTN/UIN\nof RCPT', field: 'ReceipeintGSTIN', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '150px', textAlign: 'left' } },
        { headerName: 'Receiver Name', exportHead: 'Rec.\nName', field: 'ReceiverName', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '150px', textAlign: 'left' } },
        { headerName: 'Invoice Number', exportHead: 'Invoice\nNo.', field: 'InvoiceNumber', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'left' } },
        { headerName: 'Invoice date', exportHead: 'Invoice\nDate', field: 'Invoicedate', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'left' } },
        { headerName: 'Invoice Value', exportHead: 'Invoice\nValue', field: 'InvoiceValue', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'Place of Supply', exportHead: 'Place of\nSupply', field: 'PlaceofSupply', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '120px', textAlign: 'left' } },
        { headerName: 'Reverse Charge', exportHead: 'Reverse\nChrg.', field: 'ReverseCharge', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'left' } },
        { headerName: 'Applicable Tax Rate', exportHead: 'Appl.\nTax Rate', field: 'ApplicableTaxRate', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '130px', textAlign: 'left' } },
        { headerName: 'Invoice Type', exportHead: 'Invoice\nType', field: 'InvoiceType', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'left' } },
        { headerName: 'E-Commerce GSTIN', exportHead: 'E Comm.\nGSTIN', field: 'ECommGSTIN', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'left' } },
        { headerName: 'Rate', exportHead: 'Rate', field: 'Rate', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'Loading Charge', exportHead: 'Load.\nChrg.', field: 'LoadingChrg', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'right' } },
        { headerName: 'Safe Delivery Charge', exportHead: 'Safe Dlvr.\nChrg.', field: 'SafeDlvrChrg.', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'right' } },
        { headerName: 'Cartage Amount', exportHead: 'Cartage\nChrg.', field: 'CartageChrg', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'right' } },
        { headerName: 'Freight', exportHead: 'Freight', field: 'Freight', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'Taxable Value', exportHead: 'Taxable\nValue', field: 'TaxableValue', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'right' } },
        { headerName: 'Cess Amount', exportHead: 'Cess\nAmt.', field: 'CessAmount', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'ServiceTaxAmount', exportHead: 'Service\nTax Amt.', field: 'ServiceTaxAmount', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
    ]
    const printReport = (isSave = false) => {
        setState({ ...state, load: true, generatePDF: true })
        setIsPdfLoading(true);
        jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
        jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
        const doc = new jsPDF({ orientation: 'l', format: [1800, 1272], unit: 'px', compress: true })
        doc.setProperties({
            title: `Exemp Detailed.pdf`,
            subject: 'Exemp Detailed Report',
            author: 'Maven Tech Labs Pvt. Ltd.',
            keywords: 'maven tech, Cargo system, Exemp Detailed',
            creator: 'MTLPL',
        })
        const HeaderColumns = filterData.includeBranches ?
            [
                { header: 'Report View', dataKey: 'reportViewName', xlCol: { dataType: 'string' } },
                { header: 'Report Type', dataKey: 'reportTypeName', xlCol: { dataType: 'string' } },
                { header: 'State', dataKey: 'state', xlCol: { dataType: 'string' } },
                { header: 'GSTIN', dataKey: 'GSTOpt', xlCol: { dataType: 'string' } },
                { header: 'Branches', dataKey: 'branch', xlCol: { dataType: 'string' } },
            ] : [
                { header: 'Report View', dataKey: 'reportViewName', xlCol: { dataType: 'string' } },
                { header: 'Report Type', dataKey: 'reportTypeName', xlCol: { dataType: 'string' } },
                { header: 'State', dataKey: 'state', xlCol: { dataType: 'string' } },
            ]
        autoTable(doc, {
            margin: { top: 60, left: 30, right: 30, bottom: 5 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: HeaderColumns,
            body: [filterData],
            startY: 160,
            theme: 'grid',
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                minCellHeight: 36,
                valign: 'middle',
                cellPadding: 12,
                fontSize: 18,
                fontStyle: 'normal',
                font: "Roboto",
                lineWidth: 0.6,
            },
            columnStyles: filterData.includeBranches ? {
                0: { textColor: [0, 0, 0], fontSize: 18, cellPadding: 12, minCellHeight: 36, minCellWidth: 200, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                1: { textColor: [0, 0, 0], fontSize: 18, cellPadding: 12, minCellHeight: 36, minCellWidth: 200, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                2: { textColor: [0, 0, 0], fontSize: 18, cellPadding: 12, minCellHeight: 36, minCellWidth: 200, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                3: { textColor: [0, 0, 0], fontSize: 18, cellPadding: 12, minCellHeight: 36, minCellWidth: 200, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                4: { textColor: [0, 0, 0], fontSize: 18, cellPadding: 12, minCellHeight: 36, minCellWidth: 195, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
            } :
                {
                    0: { textColor: [0, 0, 0], fontSize: 18, cellPadding: 12, minCellHeight: 36, minCellWidth: 200, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                    1: { textColor: [0, 0, 0], fontSize: 18, cellPadding: 12, minCellHeight: 36, minCellWidth: 200, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                    2: { textColor: [0, 0, 0], fontSize: 18, cellPadding: 12, minCellHeight: 36, minCellWidth: 200, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                }
            ,
            didDrawPage: function (data) {
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(18).setFont('Roboto', 'bold')
                doc.text(`Date:${filterData.FromDate} To ${filterData.ToDate}`, data.settings.margin.left, 150)
                doc.text(`${filterData.includeBranches ? `Report:Exemp (Includes Branches Having GSTIN)` : 'Report:Exemp'}`, doc.internal.pageSize.width - data.settings.margin.left, 150, "right")

            },
            showHead: "firstPage",
        })
        var totalPagesExp = '{total_pages_count_string}'
        const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
            const doc = data.doc
            // Footer
            var pageSize = doc.internal.pageSize
            var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
            var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

            var str = 'Page : ' + doc.internal.getNumberOfPages()
            if (typeof doc.putTotalPages === 'function') {
                str = str + ' of ' + totalPagesExp
            }
            doc.setFontSize(16)
            doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, "right")
            doc.setFont('Roboto', 'bold')
            doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
            doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 5)
        }
        let drawCell = function (data) {
            var rows = data.table.body
            if (data.row.section === 'head') {
                if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
                    data.cell.styles.halign = "right";
                } else {
                    data.cell.styles.halign = "left";
                }
            }
            rows.map((val) => {
                if (val.raw.isNoData) {
                    val.cells[0].text = val.raw.caption.toString();
                    val.cells[0].colSpan = val.raw.colSpan;
                    val.cells[0].styles.halign = 'center'
                }
            })
        }
        let pdfColumns = columnSummaryDefs.map((col) => {
            return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
        })
        autoTable(doc, {
            margin: { top: 100, left: 30, right: 30, bottom: 40 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: pdfColumns,
            tableLineWidth: 0.6,
            body: reportData,
            styles: {
                lineWidth: [0, 0.6, 0, 0.6]
            },
            columnStyles: {
                0: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 100, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, cellPadding: 6, halign: 'left' },
                1: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 100, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, cellPadding: 6, halign: 'left' },
                2: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 100, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, cellPadding: 6, halign: 'left' },
                3: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 80, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, cellPadding: 6, halign: 'left' },
                4: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 100, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, cellPadding: 6, halign: 'left' },
                5: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 100, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, cellPadding: 6, halign: 'left' },
                6: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 80, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, cellPadding: 6, halign: 'left' },
                7: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 90, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, cellPadding: 6, halign: 'left' },
                8: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 80, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, cellPadding: 6, halign: 'left' },
                9: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 60, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, cellPadding: 6, halign: 'right' },
                10: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 100, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, cellPadding: 6, halign: 'left' },
                11: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 60, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, cellPadding: 6, halign: 'left' },
                12: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 60, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, cellPadding: 6, halign: 'right' },
                13: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 60, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, cellPadding: 6, halign: 'right' },
                14: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 60, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, cellPadding: 6, halign: 'right' },
                15: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 60, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, cellPadding: 6, halign: 'right' },
                16: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 60, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, cellPadding: 6, halign: 'right' },
                17: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 70, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, cellPadding: 6, halign: 'right' },
                18: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 60, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, cellPadding: 6, halign: 'right' },
                19: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 60, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, cellPadding: 6, halign: 'right' },
                20: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 60, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, cellPadding: 6, halign: 'right' },
                21: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 60, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, cellPadding: 6, halign: 'right' },
                22: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 60, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, cellPadding: 6, halign: 'right' },
            },
            theme: 'grid',
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                cellPadding: 6,
                fontSize: 16,
                minCellHeight: 36,

                valign: 'middle',
                font: 'Roboto',
                fontStyle: 'normal',
                valign: 'top'
            },
            didParseCell: (data) => {
                drawCell(data)
            },
            didDrawPage: function (data) {
                doc.setTextColor(40)
                doc.addImage('/images/logo-66.png', 'JPEG', 30, 30, 50, 50)
                doc.setFontSize(26).setFont("Roboto", 'bold')
                doc.setTextColor(16, 79, 162)
                doc.text('Cargo System | GST Return Report', 30 + 60, 60)
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(22).setFont("Roboto", 'bold')
                doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 60, "right")
                jsPdfHeaderFooter(data, loginData, totalPagesExp)
            },
        })
        doc.setFont('Roboto')
        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp)
        }
        if (isSave) {
            doc.save(`Exemp Detailed ${currentDateTime}.pdf`)
        }
        setTimeout(() => {
            setState({ ...state, generatePDF: false, load: true })
            const pdfUrl = doc.output('bloburl')
            document.getElementById('output').data = pdfUrl
            // document.getElementById('output').data = doc.output('datauristring', 'Exemp Detailed.pdf')
            focusElemnt('backBtn')
        }, 2000)

    }
    const backToScreenView = () => {
        setIsPdfLoading(false)
        const data = document.getElementById('output')
        data.innerHTML = ''
    }
    return (
        <>
            <Box sx={{ ...sx.reportFlex, justifyContent: 'space-between', alignItems: 'center', marginTop: '10px' }}>
                <Typography variant="h5" display="block" sx={{ fontWeight: 600, color: '#444' }}>
                    Report For: Exemp Detailed
                </Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'center' }} className="reportButtons">
                    {!isPdfLoading ?
                        <>
                            <Item sx={sx.itemsx} className="disabled-wrapper"
                                onKeyDown={(e) => {
                                    navigation3(e, "csvfileBtn", id.reportmainButton, () => { })
                                }}
                            >
                                <ReactHtmlTableToExcel
                                    id="exportExcelBtn"
                                    className="receiveitemExcelBtn"
                                    table="ExempDetailed"
                                    filename={`Exemp Detailed Report ${currentDateTime}`}
                                    sheet="tablexls"
                                    buttonText="Export to Excel"
                                />
                            </Item>
                            <Item sx={sx.itemsx} className="disabled-wrapper"
                                onKeyDown={(e) => {
                                    navigation3(e, "exportPdf", "exportExcelBtn", () => { document.getElementById("csvfileBtn").click() })
                                }}
                            >
                                <CSVLink filename='Exemp Detailed.csv' id={"csvfileBtn"} className="receiveitembtn exportCSVBtn" data={reportData} headers={columnSummaryDefs.map((val) => ({ label: val.headerName, key: val.field }))}>
                                    Export As CSV
                                </CSVLink>
                            </Item>
                            <Item sx={sx.itemsx} className="disabled-wrapper">
                                <Button variant="outlined" id={"exportPdf"} sx={{ width: '100%' }} className="receiveitembtn"
                                    onKeyDown={(e) => {
                                        navigation3(e, "printBtn", "csvfileBtn", () => printReport(true))
                                    }}
                                    onClick={() => {
                                        printReport(true)
                                    }}>
                                    Export As PDF
                                </Button>
                            </Item>
                            <Item sx={sx.itemsx} className="disabled-wrapper">
                                <Button variant="outlined" id={"printBtn"} sx={{ width: '100%' }} className="receiveitembtn"
                                    onKeyDown={(e) => {
                                        navigation3(e, id.fromDate, "exportPdf", () => printReport())
                                    }}
                                    onClick={() => {
                                        printReport()
                                    }} >
                                    Print
                                </Button>
                            </Item>
                        </>
                        :
                        <Item sx={sx.itemsx} className="disabled-wrapper">
                            <Button variant="outlined" id={"backBtn"} sx={{ width: '100%' }} className="receiveitembtn"
                                onKeyDown={(e) => {
                                    navigation3(e, id.fromDate, id.reportmainButton, () => {
                                        backToScreenView()
                                        focusElemnt(id.reportmainButton)
                                    })
                                }}
                                onClick={backToScreenView}>
                                Back
                            </Button>
                        </Item>
                    }
                </Box>
            </Box>
            {!isPdfLoading ?
                <Box sx={{ ...sx.reportFlex }}>
                    <ExempDetailedTable columnSummaryDefs={columnSummaryDefs} reportData={reportData} tableRef={tableRef} id={"ExempDetailed"} />

                </Box>
                :
                <Box sx={{ ...sx.reportFlex, justifyContent: 'center' }}>
                    {state.generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
                    {state.load ? (
                        <object
                            id="output"
                            type="application/pdf"
                            width="100%"
                            height="440"
                            title="MTLPL -Cargo System - LR Wise Detailed Status"
                            aria-label="MTLPL -Cargo System - LR Wise Detailed Status"
                        ></object>
                    ) : (
                        ''
                    )}
                </Box>
            }
        </>
    )
}

export default ExempDetailed